import styled, { StyledComponent } from '@emotion/styled';
import { breakpoints } from '@ds/ui';
import { inkSpacingTokens } from '@ds/tokens';
import breakpointSizes from 'layouts/ApplicationLayout/objects/breakpointSizes/breakpointSizes';
import { ContainerLayoutFooterPrimaryButton, ContainerLayoutFooterSecondaryButton } from './components';

interface ContainerLayoutFooterButtonsProps {
    className?: string;
}

type ContainerLayoutFooterButtonsType = {
    Primary: typeof ContainerLayoutFooterPrimaryButton;
    Secondary: typeof ContainerLayoutFooterSecondaryButton;
} & StyledComponent<ContainerLayoutFooterButtonsProps, {}, {}>;

// @ts-ignore
const ContainerLayoutFooterButtons: ContainerLayoutFooterButtonsType = styled.div`
    display: flex;
    margin-left: ${inkSpacingTokens.spacingM};

    // MOBILE
    ${breakpoints.lessThan(breakpointSizes.xs)} {
        margin-left: 0;
        margin-top: ${inkSpacingTokens.spacingS};
        flex-direction: column;
        gap: ${inkSpacingTokens.spacingXS};

        button {
            width: 100%;
        }
    }
`;

ContainerLayoutFooterButtons.Primary = ContainerLayoutFooterPrimaryButton;
ContainerLayoutFooterButtons.Secondary = ContainerLayoutFooterSecondaryButton;

export default ContainerLayoutFooterButtons;
